<template>
  <div class="service-page">
    <section class="masthead hero-text-img-section">
      <div class="container-fluid px-0">
        <div class="row justify-content-center mt-10 border-20">
          <div class="col-lg-12 z-100 text-center">
            <h1 class="secondary-color"
              >Study Abroad Consultants Hyderabad</h1
            >
            <!-- <h2 class="page-intro-line">
 A one-stop solution to all your education needs 
              Chart Your Way to Global Success through our Study Abroad
              Consulting
            </h2> -->
            <p class="main-content-1 mt-2">
              <!-- We pave a way for you to excel in your abroad education plans by shouldering all the 
              responsibilities of admission to accommodation, without making any exceptions. What’s more, 
              all this services are offered to give you value and we do not charge a penny for it.  -->
              As education continues to change, more and more students are
              looking to study abroad for a better education. Hyderabad is a
              popular place for students to study abroad, and there are many
              study abroad consultants who can help. In the year 2024, it will
              be even harder to study abroad because the requirements will be
              stricter. So, it is more important than ever to work with
              experienced study abroad consultants. Aliff is one of the best
              study abroad consultants in Hyderabad. They can help you with
              everything you need to know about studying abroad, from finding
              the right program to getting your visa. They can also provide
              support throughout your journey, making sure that you have
              everything you need to succeed.
            </p>
          </div>
          <div class="col-lg-12 text-center abroad-hero-img">
            <img
              src="@/assets/imgs/study-abroad-hero-img.png"
              alt="Consultants Hyderabad"
              data-aos="fade-up"
              data-aos-duration="500"
              class="img-fluid responsive_ill_img"
            />
          </div>
        </div>
      </div>
    </section>

    <section class="intro-sm-section">
      <div class="container">
        <div class="row">
          <div class="col-md-12 col-lg-12 responsiv_margin_study">
            <h2
              class="main-heading-1-gradient text-center"
              data-aos="fade-down"
              data-aos-duration="500"
              >How do study abroad consultants in Hyderabad assist students with
              their applications?
            </h2>
          </div>
          <div
            class="col-md-12 col-lg-8"
            data-aos="fade-right"
            data-aos-duration="500"
          >
            <p class="main-content-1 mt-2">
              Study Abroad Consultants in Hyderabad: Assisting Students Every
              Step of the Way
            </p>
            <p class="main-content-1 mt-2">
              In an era where the global education landscape is constantly
              evolving, navigating the intricacies of studying abroad can be
              overwhelming. This is where Aliff, one of the leading study abroad
              consultants in Hyderabad, steps in. From meticulously guiding
              students through the application process to providing invaluable
              insights into various study destinations and institutions, Aliff
              offers a holistic approach to studying abroad.
            </p>
          </div>

          <div
            class="col-md-12 col-lg-4 text-center"
            data-aos="fade-left"
            data-aos-duration="500"
          >
            <img
              src="@/assets/imgs/admission-1.png"
              class="img-fluid responsive_ill_img"
            />
          </div>
        </div>
      </div>
    </section>

    <section class="intro-sm-section section-spacing contact-us-section">
      <div class="container">
        <div class="row">
          <div class="col-md-12 col-lg-12 responsiv_margin_study">
            <h2
              class="main-heading-1-gradient text-center"
              data-aos="fade-down"
              data-aos-duration="500"
              >Find your right course and institution
            </h2>
          </div>

          <div
            class="col-md-12 col-lg-4 text-center"
            data-aos="fade-right"
            data-aos-duration="500"
          >
            <img
              src="@/assets/imgs/departure.png"
              class="img-fluid responsive_ill_img"
            />
          </div>

          <div
            class="col-md-12 col-lg-8"
            data-aos="fade-left"
            data-aos-duration="500"
          >
            <p class="main-content-1 mt-2">
              One of the primary challenges faced by students aspiring to study
              abroad is selecting the right course and institution that aligns
              with their academic goals and career aspirations. In 2024, with an
              abundance of choices available, this decision becomes even more
              daunting. However, Aliff's team of experienced consultants
              simplifies this process by conducting comprehensive assessments of
              students' academic backgrounds, interests, and career objectives.
              Through personalised counselling sessions and thorough research,
              they assist students in identifying the most suitable courses and
              institutions tailored to their individual needs.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="intro-sm-section">
      <div class="container">
        <div class="row">
          <div class="col-md-12 col-lg-12 responsiv_margin_study">
            <h2
              class="main-heading-1-gradient text-center"
              data-aos="fade-down"
              data-aos-duration="500"
              >Expert Guidance from Top Study Abroad Consultants
            </h2>
          </div>
          <div
            class="col-md-12 col-lg-8"
            data-aos="fade-right"
            data-aos-duration="500"
          >
            <p class="main-content-1 mt-2">
              The journey of studying abroad extends beyond just filling out
              application forms; it requires meticulous planning, strategic
              decision-making, and expert guidance. Aliff's team comprises
              seasoned professionals with extensive knowledge and expertise in
              the field of international education. Whether it's navigating the
              complexities of visa applications, preparing for standardised
              tests, or securing scholarships, their guidance ensures that
              students are well-prepared at every stage of the application
              process.
            </p>
          </div>

          <div
            class="col-md-12 col-lg-4 text-center"
            data-aos="fade-left"
            data-aos-duration="500"
          >
            <img
              src="@/assets/imgs/Illustration 16@1x.png"
              class="img-fluid responsive_ill_img"
            />
          </div>
        </div>
      </div>
    </section>

    <section
      class="intro-sm-section section-spacing contact-us-section"
      style="margin: 0px !important"
    >
      <div class="container">
        <div class="row">
          <div class="col-md-12 col-lg-12 responsiv_margin_study">
            <h2
              class="main-heading-1-gradient text-center"
              data-aos="fade-down"
              data-aos-duration="500"
              >Why Choose Aliff?
            </h2>
            <p
              class="main-content-1 mt-2 text-center"
              data-aos="fade-up"
              data-aos-duration="500"
            >
              In a sea of study abroad consultants in Hyderabad, what sets Aliff
              apart is its unwavering commitment to student success. Here are
              some compelling reasons why Aliff should be your preferred choice
            </p>
          </div>

          <div
            class="col-md-12 col-lg-4 text-center"
            data-aos="fade-right"
            data-aos-duration="500"
          >
            <img
              src="@/assets/imgs/Illustration 08@1x.png"
              class="img-fluid responsive_ill_img"
            />
          </div>

          <div
            class="col-md-12 col-lg-8"
            data-aos="fade-left"
            data-aos-duration="500"
          >
            <ul class="benefits_ul">
              <li>
                <b>Personalised Approach:</b> Aliff understands that each
                student is unique, with distinct academic backgrounds,
                aspirations, and challenges. Therefore, they adopt a
                personalised approach to counselling, ensuring that every
                student receives tailored guidance and support.
              </li>
              <li>
                <b>Extensive Network:</b> With years of experience in the
                industry, Aliff has established a robust network of partner
                institutions, universities, and industry experts worldwide. This
                network not only facilitates smoother admission processes but
                also opens doors to a myriad of opportunities for students.
              </li>
              <li>
                <b>Comprehensive Services:</b> From initial consultation to
                post-departure support, Aliff offers a wide range of services
                aimed at simplifying the study abroad journey. Whether it's
                assistance with documentation, visa processing, or accommodation
                arrangements, they leave no stone unturned in ensuring a
                hassle-free experience for students.
              </li>
              <li>
                <b>Track Record of Success:</b>Over the years, Aliff has helped
                countless students fulfil their dreams of studying abroad. Their
                track record of success speaks volumes about their dedication,
                professionalism, and commitment to excellence.
              </li>
              <li>
                <b>Adaptability to 2024 Trends:</b>Recognizing the evolving
                trends and dynamics of the education sector in 2024, Aliff has
                continually adapted its services to meet the changing needs of
                students. Whether it's leveraging technology for virtual
                counselling sessions or staying updated on the latest visa
                regulations, they remain at the forefront of innovation.
              </li>
            </ul>
          </div>
          <div class="col-md-12 col-lg-12">
            <p class="main-content-1 mt-3 text-center">
              The decision to study abroad is a significant milestone in one's
              academic and professional journey. With Aliff by your side, this
              journey becomes not only achievable but also immensely rewarding.
              As the premier study abroad consultants in Hyderabad, Aliff stands
              as a trusted partner, guiding students towards a brighter and more
              promising future on the global stage.
            </p>
          </div>
        </div>
      </div>
    </section>

    <ContactusSection />

    <!-- <RecentPostSection :recentPostsData="recentPostData['abroad-page']['data-1']" /> -->

    <RecentPostSection
      :recentPostsData="recentPostData['abroad-page']['data-1']"
    />
  </div>
</template>

<script>
  import homeServices from "@/apiServices/homeServices";
  import BookFreeCounselling from "@/components/partials/BookFreeCounselling.vue";
  import { DASHBOARD_REGISTER_URL } from "@/config";
  import VideoTestimonialSlider from "@/components/partials/VideoTestimonialSlider.vue";
  import TextTestimonialSlider from "@/components/partials/TextTestimonialSlider.vue";
  import RecentPostSection from "@/components/partials/RecentPostSection.vue";
  import ContactusSection from "@/components/partials/ContactusSection.vue";
  export default {
    metaInfo: {
      title:
        "Study Abroad Consultants Hyderabad - Consultants Hyderabad -Aliff",
      htmlAttrs: {
        lang: "en-US",
      },
      meta: [
        { charset: "utf-8" },
        {
          name: "description",
          content:
            "Looking for Study Abroad Consultants Hyderabad? Aliff offers the best Study Abroad Consultants in Hyderabad. Start your Journey with our expert consultant.",
        },
        { name: "viewport", content: "width=device-width, initial-scale=1" },
      ],
    },
    components: {
      BookFreeCounselling,
      VideoTestimonialSlider,
      TextTestimonialSlider,
      RecentPostSection,
      ContactusSection,
    },
    data() {
      return {
        service: [],
        showPlan: false,
        DASHBOARD_REGISTER_URL,
        videoSlider: {
          //autoplay: true,
          //autoplaySpeed: 2500,
          arrows: false,
          dots: true,
          infinite: false,
          slidesToScroll: 1,
          slidesToShow: 2.5,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 1.5,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
          ],
        },
        pricingSlider: {
          //autoplay: true,
          //autoplaySpeed: 2500,
          arrows: false,
          dots: false,
          infinite: false,
          slidesToScroll: 1,
          slidesToShow: 3,
          responsive: [
            {
              breakpoint: 1300,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 1.5,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
          ],
        },

        postSlider: {
          //autoplay: true,
          //autoplaySpeed: 2500,
          arrows: true,
          dots: false,
          infinite: false,
          slidesToScroll: 1,
          slidesToShow: 3,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 768,
              settings: {
                arrows: false,
                dots: true,
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
          ],
        },
      };
    },
    methods: {
      bookFreeCounselling() {},
      clickShowPlan() {
        this.showPlan = !this.showPlan;
      },
      async getServicePlan() {
        try {
          const response = await homeServices.getServicesAndPlans({
            service_id: 3,
          });
          if (response.data.status) {
            this.service = response.data.data[0];
          }
        } catch (err) {
          console.log("Error in getting getServicePlan ", err);
        }
      },
      addCommas(amt) {
        return amt.toLocaleString("en-IN");
      },
    },
    beforeMount() {
    document.querySelector('meta[name="description"]').setAttribute('content',"Looking for Study Abroad Consultants Hyderabad? Aliff offers the best Study Abroad Consultants in Hyderabad. Start your Journey with our expert consultant.");
      
      this.getServicePlan();
    },
  };
</script>
<style>
  .responsiv_margin_study {
    margin-bottom: 40px;
  }
  @media screen and (max-width: 768px) {
    .responsive_ill_img {
      width: 200px;
    }
    .responsiv_margin_study {
      margin: 20px 0px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/StudyAbroadCounsellingHyd.vue